import style from "./style.scss";

const Emoji = ({ children }) => <span class={style.emoji}>{children}</span>;

export default Emoji;
